import { all, takeEvery, put } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
import * as API from "../api";
import Helper from "../../helpers/helpers";

const addTrackNo = (data, trackNo) => {
  if (data instanceof FormData) {
    data.append("track_no", trackNo);
  } else {
    data.track_no = trackNo;
  }
};

export function* loadLuckyDrawCount() {
  yield takeEvery(actionTypes.LOAD_LUCKY_DRAW_COUNT, function*(action) {
    if (!action.data) action.data = {};
    action.data.track_no = Helper.generateTrackNo("LUCKYDRAWCOUNT");

    yield put(actions.enableLoading());
    try {
      const response = yield API.loadLuckyDrawCount(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadLuckyDrawCountSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLuckyDrawCountFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLuckyDrawCountFail());
    }
  });
}

export function* loadLuckyDrawList() {
  yield takeEvery(actionTypes.LOAD_LUCKY_DRAW_LIST, function*(action) {
    if (!action.data) action.data = {};
    const search = action.data.search ? action.data.search : "";
    action.data.track_no = Helper.generateTrackNo(`LUCKYDRAWLIST${search}`);

    yield put(actions.enableLoading());
    try {
      const response = yield API.loadLuckyDrawList(action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadLuckyDrawListSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLuckyDrawListFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLuckyDrawListFail());
    }
  });
}

export function* loadLuckyDrawDetail() {
  yield takeEvery(actionTypes.LOAD_LUCKY_DRAW_DETAIL, function*(action) {
    if (!action.data) action.data = {};
    action.data.track_no = Helper.generateTrackNo("LUCKYDRAWDETAIL");

    yield put(actions.enableLoading());
    try {
      const response = yield API.loadLuckyDrawDetail(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadLuckyDrawDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLuckyDrawDetailFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLuckyDrawDetailFail());
    }
  });
}

export function* createLuckyDraw() {
  console.log("createLuckyDraw")
  yield takeEvery(actionTypes.CREATE_LUCKY_DRAW, function*(action) {
    if (!action.data) action.data = {};
    addTrackNo(action.data, Helper.generateTrackNo("CREATELUCKYDRAW"));

    yield put(actions.enableLoading());
    try {
      const response = yield API.createLuckyDraw(action.data);
      if (response.data.success) {
        yield put(actions.createLuckyDrawSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.createLuckyDrawFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.createLuckyDrawFail());
    }
  });
}

export function* updateLuckyDraw() {
  yield takeEvery(actionTypes.UPDATE_LUCKY_DRAW, function*(action) {
    if (!action.data) action.data = {};
    addTrackNo(action.data, Helper.generateTrackNo("UPDATELUCKYDRAW"));

    yield put(actions.enableLoading());
    try {
      const response = yield API.updateLuckyDraw(action.id, action.data);
      if (response.data.success) {
        yield put(actions.updateLuckyDrawSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.updateLuckyDrawFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateLuckyDrawFail());
    }
  });
}

export function* updateLuckyDrawActive() {
  yield takeEvery(actionTypes.UPDATE_LUCKY_DRAW_ACTIVE, function*(action) {
    if (!action.data) action.data = {};
    addTrackNo(action.data, Helper.generateTrackNo("UPDATELUCKYDRAWACTIVE"));

    yield put(actions.enableLoading());
    try {
      const response = yield API.updateLuckyDrawActive(action.id, action.data);
      if (response.data.success) {
        yield put(actions.updateLuckyDrawActiveSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.updateLuckyDrawActiveFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateLuckyDrawActiveFail());
    }
  });
}

export function* removeLuckyDraw() {
  yield takeEvery(actionTypes.REMOVE_LUCKY_DRAW, function*(action) {
    if (!action.data) action.data = {};
    action.data.track_no = Helper.generateTrackNo("REMOVELUCKYDRAW");

    yield put(actions.enableLoading());
    try {
      const response = yield API.removeLuckyDraw(action.id, action.data);
      if (response.data.success) {
        yield put(actions.removeLuckyDrawSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeLuckyDrawFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeLuckyDrawFail());
    }
  });
}

export function* createLuckyDrawPrize() {
  yield takeEvery(actionTypes.CREATE_LUCKY_DRAW_PRIZE, function*(action) {
    if (!action.data) action.data = {};
    addTrackNo(action.data, Helper.generateTrackNo("CREATELUCKYDRAWPRIZE"));

    yield put(actions.enableLoading());
    try {
      const response = yield API.createLuckyDrawPrize(action.id, action.data);
      if (response.data.success) {
        yield put(actions.createLuckyDrawPrizeSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.createLuckyDrawPrizeFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.createLuckyDrawPrizeFail());
    }
  });
}

export function* updateLuckyDrawPrize() {
  yield takeEvery(actionTypes.UPDATE_LUCKY_DRAW_PRIZE, function*(action) {
    if (!action.data) action.data = {};
    addTrackNo(action.data, Helper.generateTrackNo("UPDATELUCKYDRAWPRIZE"));

    yield put(actions.enableLoading());
    try {
      const response = yield API.updateLuckyDrawPrize(action.id, action.data);
      if (response.data.success) {
        yield put(actions.updateLuckyDrawPrizeSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.updateLuckyDrawPrizeFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateLuckyDrawPrizeFail());
    }
  });
}

export function* removeLuckyDrawPrize() {
  yield takeEvery(actionTypes.REMOVE_LUCKY_DRAW_PRIZE, function*(action) {
    if (!action.data) action.data = {};
    action.data.track_no = Helper.generateTrackNo("REMOVELUCKYDRAWPRIZE");

    yield put(actions.enableLoading());
    try {
      const response = yield API.removeLuckyDrawPrize(action.id, action.data);
      if (response.data.success) {
        yield put(actions.removeLuckyDrawPrizeSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.removeLuckyDrawPrizeFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.removeLuckyDrawPrizeFail());
    }
  });
}

export function* loadLuckyDrawPrize() {
  yield takeEvery(actionTypes.LOAD_LUCKY_DRAW_PRIZE, function*(action) {
    if (!action.data) action.data = {};
    action.data.track_no = Helper.generateTrackNo("LUCKYDRAWPRIZE");

    yield put(actions.enableLoading());
    try {
      const response = yield API.loadLuckyDrawPrize(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadLuckyDrawPrizeSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLuckyDrawPrizeFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLuckyDrawPrizeFail());
    }
  });
}

export function* loadLuckyDrawParticipant() {
  yield takeEvery(actionTypes.LOAD_LUCKY_DRAW_PARTICIPANT, function*(action) {
    if (!action.data) action.data = {};
    action.data.track_no = Helper.generateTrackNo("LUCKYDRAWPARTICIPANT");

    yield put(actions.enableLoading());
    try {
      const response = yield API.loadLuckyDrawParticipant(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadLuckyDrawParticipantSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLuckyDrawParticipantFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLuckyDrawParticipantFail());
    }
  });
}

export function* updateLuckyDrawParticipantEligible() {
  yield takeEvery(actionTypes.UPDATE_LUCKY_DRAW_PARTICIPANT_ELIGIBLE, function*(action) {
    if (!action.data) action.data = {};
    addTrackNo(action.data, Helper.generateTrackNo("UPDATELUCKYDRAWPARTICIPANTELIGIBLE"));

    yield put(actions.enableLoading());
    try {
      const response = yield API.updateLuckyDrawParticipantEligible(action.id, action.data);
      if (response.data.success) {
        yield put(actions.updateLuckyDrawParticipantEligibleSuccess());
        yield put(actions.toastSuccess(response.data.message));
      } else {
        alert(response.data.message);
        yield put(actions.updateLuckyDrawParticipantEligibleFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.updateLuckyDrawParticipantEligibleFail());
    }
  });
}

export function* loadLuckyDrawResult() {
  yield takeEvery(actionTypes.LOAD_LUCKY_DRAW_RESULT, function*(action) {
    if (!action.data) action.data = {};
    action.data.track_no = Helper.generateTrackNo("LUCKYDRAWRESULT");

    yield put(actions.enableLoading());
    try {
      const response = yield API.loadLuckyDrawResult(action.id, action.data);
      if (response.data.success && response.data.data) {
        yield put(actions.loadLuckyDrawResultSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.loadLuckyDrawResultFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
      yield put(actions.loadLuckyDrawResultFail());
    }
  });
}

export default function* luckyDrawSagas() {
  yield all([
    loadLuckyDrawCount(),
    loadLuckyDrawList(),
    loadLuckyDrawDetail(),
    createLuckyDraw(),
    updateLuckyDraw(),
    updateLuckyDrawActive(),
    removeLuckyDraw(),
    createLuckyDrawPrize(),
    updateLuckyDrawPrize(),
    removeLuckyDrawPrize(),
    loadLuckyDrawPrize(),
    loadLuckyDrawParticipant(),
    updateLuckyDrawParticipantEligible(),
    loadLuckyDrawResult()
  ]);
}